function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("style", null, ".gasLeak-icon{fill:url(#gasLeak);}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "gasLeak",
  x1: 35,
  y1: 8.1,
  x2: 35,
  y2: 62.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FAB800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "70%",
  stopColor: "#038FC7"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "gasLeak-icon",
  d: "M52.8,86.5h-5.5c-14.8,0-15-14.8-15-15V58.8c0-14.8,14.8-15,15-15h5.5c14.8,0,15,14.8,15,15v12.7  C67.7,86.4,52.9,86.5,52.8,86.5z M47.2,46.6c-0.5,0-12.2,0.2-12.2,12.2v12.7c0,0.5,0.2,12.2,12.2,12.2h5.5c0.5,0,12.2-0.2,12.2-12.2  V58.8c0-0.5-0.2-12.2-12.2-12.2H47.2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "gasLeak-icon",
  d: "M50,35c-4.3,0-7.9-5.6-7.9-9.2c0-3.3,1.2-5.1,1.4-5.2c0.3-0.5,0.9-0.7,1.5-0.5c0.5,0.1,1,0.6,1,1.1c0.1,0.5,0.5,2.2,1.4,2.7  c-0.5-1.8-1-4.5-0.6-6.8c0.7-3.6,4-7,4.1-7.1c0.4-0.4,1-0.5,1.5-0.3c0.5,0.2,0.9,0.7,0.9,1.3c0,1,0.1,3.7,0.3,4.8  c0.2,1.4,0.9,2.3,1.8,3.4c1.2,1.6,2.6,3.4,2.6,6.8C57.9,32.2,53.9,35,50,35z M44.9,25.4c0,0.2,0,0.3,0,0.5c0,2.2,2.7,6.4,5.1,6.4  c2.5,0,5.1-1.6,5.1-6.3c0-2.5-0.9-3.7-2-5.1c-0.9-1.2-1.9-2.5-2.3-4.6c-0.1-0.4-0.1-0.8-0.1-1.4c-0.5,0.9-1,1.8-1.1,2.8  c-0.6,3.1,1.2,7.5,1.2,7.5c0.2,0.4,0.1,0.9-0.1,1.3c-0.3,0.4-0.7,0.6-1.2,0.6c-0.2,0-2-0.1-3.2-0.7C45.7,26.1,45.2,25.8,44.9,25.4z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "gasLeak-icon",
  d: "M44.1,17.8c-0.7,0-1.3-0.5-1.4-1.2c0-0.2-0.1-1.5,0.7-3.7c0.6-1.6,2-2.9,2.2-3c0.6-0.5,1.4-0.5,2,0.1c0.5,0.6,0.5,1.4-0.1,2  c-0.3,0.3-1.1,1.1-1.5,2c-0.6,1.5-0.5,2.4-0.5,2.4c0.1,0.8-0.5,1.4-1.3,1.5C44.1,17.8,44.1,17.8,44.1,17.8z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "gasLeak-icon",
  d: "M56.2,13.7c-0.1,0-0.2,0-0.3,0c-0.7-0.2-1.2-0.9-1-1.7c0,0,0.3-1.3,0.1-2.4C54.8,9,54.2,7.7,53.8,7  c-0.4-0.7-0.2-1.5,0.5-1.9C55,4.8,55.8,5,56.2,5.7c0.2,0.3,1.2,2.2,1.5,3.4c0.3,1.7-0.1,3.4-0.2,3.6C57.3,13.3,56.8,13.7,56.2,13.7z  "
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "gasLeak-icon",
  d: "M51.1,34.5c-0.1,0-0.3,0-0.4-0.1c-0.7-0.2-1.1-1-0.9-1.7c0.1-0.2,0.2-1.1,0.1-1.7c-0.2-0.8-0.5-1.2-0.5-1.2  c-0.4-0.6-0.3-1.5,0.3-1.9c0.6-0.4,1.5-0.3,1.9,0.3c0.1,0.1,0.6,0.9,0.9,2.2c0.4,1.4-0.1,3-0.1,3.1C52.3,34.1,51.7,34.5,51.1,34.5z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "gasLeak-icon",
  d: "M59.3,93.8H40.7c-0.8,0-1.4-0.6-1.4-1.4v-7.3c0-0.8,0.6-1.4,1.4-1.4h18.6c0.8,0,1.4,0.6,1.4,1.4v7.3  C60.7,93.2,60.1,93.8,59.3,93.8z M42.2,91h15.7v-4.4H42.2V91z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "gasLeak-icon",
  d: "M59.7,40.8H40.3c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4h19.4c0.8,0,1.4,0.6,1.4,1.4S60.5,40.8,59.7,40.8z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "gasLeak-icon",
  d: "M68.6,66.5L68.6,66.5l-37.1,0c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4l0,0l37.1,0c0.8,0,1.4,0.6,1.4,1.4  S69.3,66.5,68.6,66.5z"
});

function SvgGasLeak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasLeak);
export default __webpack_public_path__ + "static/media/gasLeak.2d8cc7fb.svg";
export { ForwardRef as ReactComponent };